// global/search/search
$(document).ready(function () {
    //initSearchInputHeaderDesktop();
    //initSearchInputHeaderMobile();

    $('#show-search-mobile-header').click(function () {
        if ($('.left-menu').hasClass('is-active')) {
            //change the icon
            $('.btn-menu').toggleClass('is-active');
            //close the menu
            $('.left-menu').toggleClass('is-active');
            $('body').removeClass('menu-active');
        }
        if (!$('#show-search-mobile-header').hasClass('is-open')) {
            $('#navigation__search').select2('open');
        }
        $(this).toggleClass('is-open');
    });

    $('.select2-container--below').click();
    $('.search--navigation .select2-search__field').focus();
    $('.select2-container--below').addClass('select2-container--open');
});

// ================================================
// Attach data-image to option in select 2 (nav search)
// ================================================

function formatResult(opt) {
    if (opt.children !== undefined) {
        return $('<span><i class="icono ' + opt.icon + '"></i>' + opt.text + '</span>');
    }

    if (opt.type === 'category') {
        var $opt = $(
            '<a class="search-categories">' +
            '<img src="' + opt.thumb + '" class="search-categories__img" />' +
            '<span class="search-categories__text">' +
            '<span class="search-categories__category">' +
            opt.pill + '' +
            '</span> ' +
            opt.name + '' +
            '</span>' +
            '</a>'
        );
        return $opt;
    }

    if (opt.type === 'serie') {
        var $opt = $(
            '<a class="search-videos">' +
            '<span class="icon-search"></span> ' +
            '<span class="search-video__text"> ' +
            opt.name + '' +
            '</span>' +
            '</a>'
        );
        return $opt;
    }


    if (opt.type === 'video') {
        var $opt = $(
            '<a class="search-videos">' +
            '<span class="icon-search"></span> ' +
            '<span class="search-video__text"> ' +
            opt.title + '' +
            '</span>' +
            '</a>'
        );
        return $opt;
    }

    return opt.text;
}

// ================================================
// Relate template output and displaying the elements after page load.
//Matcher is modified to hide optgroup if there're no children
// ================================================

$(document).ready(function() {
  $("#navigation__search").select2({
    ajax: {
      url: global_tokyvideo_search_api,
      dataType: "json",
      delay: 250,
      data: function(params) {
        return {
          q: params.term, // search term
          page: params.page,
          wr: new URL(window.location.href).searchParams.get("wr"),
        };
      },
    },
    templateResult: formatResult,
    dropdownParent: $(".search--navigation"),
    placeholder: "Buscar videos...", 
    minimumInputLength: 3,
    language: {
      inputTooShort: function() {
        return "";
      },
    },
    allowClear: true,
    matcher: function(params, data) {
      //hide title when optgroup has no children
      var original_matcher = $.fn.select2.defaults.defaults.matcher;
      var result = original_matcher(params, data);
      if (result && result.children.length <= 0) {
        return null;
      }
      return result;
    },
  });

  //show search after js and css are loaded
  $(".search--navigation").show();
  //open links in self window
  //delete search term after search is complete
  $("#navigation__search").on("select2:select", function(e) {
    currentQuery = currentQuery == undefined ? "" : currentQuery;
    e.params = e.params === undefined ? { data: { id: -1 } } : e.params;
    e.params.data.id = e.params.data.id === undefined ? -1 : e.params.data.id;

    if (e.params.data.id === -1 && currentQuery.trim().length > 0) {
      window.location = global_tokyvideo_search_url + "?q=" + currentQuery + '&wr=' + (new URL(window.location.href).searchParams.get("wr") ? true : false);
      return;
    }
    window.open(e.params.data.id, "_self");
    $("#navigation__search")
      .val(null)
      .trigger("change");
  });

  $(document).on(
    "keyup",
    ".search--navigation .select2-search__field",
    function(e) {
      $(".search--navigation .select2-selection--single").removeClass(
        "focused"
      );
      $(".search--navigation .select2-search__field").removeClass("focused");

      if (e.which === 13) {
        var query;
        if (undefined === currentQuery || currentQuery.length === 0) {
          query = $(".select2-search input").prop("value");
        } else {
          query = currentQuery;
        }
        if (query.length >= 1) {
          window.location = global_tokyvideo_search_url + "?q=" + query + '&wr=' + (new URL(window.location.href).searchParams.get("wr") ? true : false);
        } else {
          e.preventDefault();
          return false;
        }
      }
      /*
        $('.select2-search__field').addClass("focused");
        if ($('.select2-search__field').hasClass("focused")) {
        } else { }
        */
    }
  );

  //Add placeholder to input search
  $("#navigation__search").on("select2:open", function() {
    $(".search--navigation").addClass("visible");
    $("body").addClass("mobile-search-on");
    setTimeout(function() {
      $(".search--navigation .select2-search__field").focus();
    });
  });

  var currentQuery = "";
  $("#navigation__search").on("select2:closing", function() {
    currentQuery = $(".select2-search input").prop("value");
    $(".select2-search__field").removeClass("focused");
    $(".search--navigation").removeClass("visible");
  });
  $("#navigation__search").on("select2:close", function() {
    $(".search--navigation .select2-search__field").attr("placeholder", null);
    $(".search--navigation").removeClass("visible");
    $("body").removeClass("mobile-search-on");

    setTimeout(function() {
      $("#show-search-mobile-header").removeClass("is-open");
    });
  });

  $("#navigation__search-btn").on("click touchend", function() {
    currentQuery = $(".select2-search input").prop("value");
    if (currentQuery === undefined || currentQuery.trim().length <= 0) {
      $(".search--navigation .select2-selection--single").addClass("focused");
      $(".search--navigation .select2-search__field").addClass("focused");
      /*$("#navigation__search").trigger({
                type: 'select2:closing'
            });*/

      return false;
    } else {
      $("#navigation__search").trigger({
        type: "select2:select",
      });
    }
  });
});

function validateForm() {
  if ($(".txt-search").val().length == 0) {
    $(".error404 .big-wrapper .search .txt-search").addClass("focused");
    return false;
  } else {
    document.getElementById("searchForm").submit();
  }
}
